// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue';
import VueI18n from 'vue-i18n'; // 引入国际化的插件包
import ElementUI from 'element-ui';

import Cookies from 'js-cookie';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VueI18n) // 全局注册国际化包
Vue.use(ElementUI);


/* 路由 */
import router from './router'

/* axios */
import axios3 from './api'
import api from './api/api'
Vue.prototype.http = axios3;
Vue.prototype.api = api;

import axios from 'axios'
//其他vue组件中就可以this.$axios调用使用
Vue.prototype.$axios = axios

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = i18n.t(to.meta.title);
    }
    next();
});

import i18n from './lang'
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium' ,  // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
import Lang from './components/Lang'

Vue.component('Lang', Lang)

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js